export class ActivationGate {
  readonly suppressionMs: number;
  #lastTarget: EventTarget | null = null;
  #lastKeyboardAt = Number.NEGATIVE_INFINITY;

  constructor(suppressionMs = 750) {
    this.suppressionMs = suppressionMs;
  }

  runKeyboard(event: KeyboardEvent, activate: () => void, now = performance.now()): boolean {
    if (event.key !== "Enter") return false;
    if (event.repeat) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
    event.preventDefault();
    event.stopPropagation();
    this.#lastTarget = event.currentTarget ?? event.target;
    this.#lastKeyboardAt = now;
    activate();
    return true;
  }

  runClick(event: MouseEvent, activate: () => void, now = performance.now()): boolean {
    const target = event.currentTarget ?? event.target;
    if (target === this.#lastTarget && now - this.#lastKeyboardAt < this.suppressionMs) {
      event.preventDefault();
      return false;
    }
    activate();
    return true;
  }
}
